/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
//import { observer } from 'mobx-react';
import { Icon } from 'semantic-ui-react';
import Chart from 'chart.js/auto';
import cx from 'classnames';
import api from '../../api';
import SecurityDetailModal from '../Modal/SecurityDetailModal';
import './SecuritySummaryView.css';

class SecuritySummaryView extends Component {
  constructor(props) {
    super(props);
    this.securityStatusChart = null;
    this.state = {
      isOpenMSD: false,
      cveData: {},
      selectedCode: '',
    };
    this.handleSecurityDetailModal = this.handleSecurityDetailModal.bind(this);
    this.handleMSDClose = this.handleMSDClose.bind(this);
  }

  componentDidMount() {
    if (this.lineChart) {
      this.drawSecurityLineChart();
    }
  }

  componentWillUnmount() {
    if (this.securityStatusChart) {
      this.securityStatusChart.destroy();
    }
  }

  handleMSDClose() {
    this.setState({
      isOpenMSD: false,
    });
  }

  handleSecurityDetailModal(e, value) {
    const data = {
      security_name: value,
    };
    api
      .getComponentSecurityDetail(data)
      .then((response) => {
        this.setState({
          cveData: response.response,
          selectedCode: value,
          isOpenMSD: true,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  calcPercentages = (hiddenArray, data) => {
    const percentageData = [];
    let i = 0;

    for (i; i < data.length; i++) {
      percentageData.push([]);
    }

    Object.keys(data[0]).forEach((innerKey) => {
      let sum = 0;
      Object.keys(data).forEach((outerKey) => {
        sum += data[outerKey][innerKey];
      });

      Object.keys(data).forEach((outerKey) => {
        if (hiddenArray[outerKey]) {
          percentageData[outerKey][innerKey] = 0;
        } else {
          percentageData[outerKey][innerKey] = (data[outerKey][innerKey] / sum) * 100;
          if (isNaN(parseFloat(percentageData[outerKey][innerKey]))) {
            percentageData[outerKey][innerKey] = 0;
          }
        }
      });
    });
    return percentageData;
  };

  drawSecurityLineChart() {
    const { translate } = this.props;
    if (this.securityStatusChart) {
      this.securityStatusChart.destroy();
      this.securityStatusChart = null;
    }

    const { trendOfSecurity } = this.props.file;
    const dataSet = [];

    const undecidedArray = trendOfSecurity.map((item) => {
      return item.undecided;
    });

    dataSet.push(undecidedArray);

    const resolvedArray = trendOfSecurity.map((item) => {
      return item.resolved;
    });

    dataSet.push(resolvedArray);

    const disregardedArray = trendOfSecurity.map((item) => {
      return item.disregarded;
    });

    dataSet.push(disregardedArray);

    const hiddenArray = [];
    let i = 0;

    for (i; i < dataSet.length; i++) {
      hiddenArray.push(null);
    }

    const percentageData = this.calcPercentages(hiddenArray, dataSet);

    const monthArray = trendOfSecurity.map((item) => {
      return item.month;
    });

    const config = {
      type: 'line',
      data: {
        labels: monthArray,
        datasets: [
          {
            backgroundColor: '#21beff',
            borderColor: '#21beff',
            label: translate('panel.menu.undecided'),
            data: percentageData[0],
            fill: true,
            pointStyle: false,
          },
          {
            backgroundColor: '#61e286',
            borderColor: '#61e286',
            label: translate('panel.menu.resolved'),
            data: percentageData[1],
            fill: true,
            pointStyle: false,
          },
          {
            backgroundColor: '#D0D0D0',
            borderColor: '#D0D0D0',
            label: translate('panel.menu.disregarded'),
            data: percentageData[2],
            fill: true,
            pointStyle: false,
          },
        ],
      },
      options: {
        plugins: {
          /*
          title: {
            display: true,
            position: 'top',
            text: translate('dashboard.trend_security_issue_status'),
            color: '#ffffff',
            font: {
              size: 8,
            }
          },
          */
          tooltip: {
            mode: 'index',
            intersect: false,
            callbacks: {
              label(context) {
                let label = context.dataset.label || '';
                if (label) {
                  label += ': ';
                }

                if (context.parsed.y !== null) {
                  label += `${Math.round(context.parsed.y)}%`;
                }

                return label;
              }
            },
          },
          legend: {
            position: 'bottom',
            labels: {
              boxWidth: 12,
              color: '#ffffff',
              font: {
                size: 9,
              }
            },
          },
        },
        scales: {
          y: {
            type: 'linear',
            grace: '5%',
            stacked: true,
            min: 0,
            max: 100,
            ticks: {
              padding: 2,
              font: {
                size: 9,
              },
              color: '#afafaf',
              callback(value) {
                return `${value}%`;
              }
            },
          },
          x: {
            lineHeight: '50px',
            ticks: {
              padding: 5,
              font: {
                size: 9,
              },
              color: '#afafaf',
            },
          },
        },
      },
    };

    const ctx = this.lineChart.getContext('2d');
    this.securityStatusChart = new Chart(ctx, config);
  }

  abbreviateNumber(value) {
    let newValue = value;
    if (value >= 10000) {
      const suffixes = ['', 'K', 'M', 'B', 'T'];
      const suffixNum = Math.floor(` ${value}`.length / 4);
      let shortValue = '';
      let i = 4; //precision
      for (i; i >= 1; i--) {
        shortValue = parseFloat(
          (suffixNum !== 0 ? value / (1000 ** suffixNum) : value).toPrecision(i) // prettier-ignore
        ); // ** : Math.pow()
        const dotLessShortValue = `${shortValue} `.replace(/[^a-zA-Z 0-9]+/g, '');
        if (dotLessShortValue.length <= 4) {
          break;
        }
      }
      //if (shortValue % 1 !== 0) {
      //const shortNum = shortValue.toFixed(1);
      //console.log(shortNum);
      //}
      newValue = shortValue + suffixes[suffixNum];
    }
    return newValue;
  }

  render() {
    const { cveData } = this.state;
    const { translate } = this.props;

    return (
      <table className="security_summary summary_item_table small">
        <colgroup>
          <col style={{ width: '20%' }} />
          <col style={{ width: '30%' }} />
          <col style={{ width: '25%' }} />
          <col style={{ width: '25%' }} />
        </colgroup>
        <tbody>
          <tr>
            <td>
              <div className="summary_item">
                <p className="label">{translate('panel.menu.security_risk')}</p>
                <p className="value">
                  {this.abbreviateNumber(this.props.file.securityCount.total)}
                  {this.props.file.hasExploit ? (<Icon name="bug" />) : null}
                </p>
              </div>
              <div className="summary_chart square_chart">
                <div>{this.abbreviateNumber(this.props.file.securityCount.critical)}</div>
                <div>{this.abbreviateNumber(this.props.file.securityCount.low)}</div>
                <div>{this.abbreviateNumber(this.props.file.securityCount.high)}</div>
                <div>{this.abbreviateNumber(this.props.file.securityCount.medium)}</div>
              </div>
            </td>
            <td>
              {/** trendOfSecurity */}
              <div
                //className="summary_chart line"
                style={{
                  width: '250px', height: '100px', position: 'relative', marginLeft: '8px'
                }}
              >
                <canvas
                  ref={(ref) => { this.lineChart = ref; }}
                />
              </div>
            </td>
            <td>
              <div className="list_wrap">
                <p className="list_title">{translate('panel.menu.most_found_security_risks')}</p>
                <ul>
                  {this.props.file.mostFound
                    ? this.props.file.mostFound.map((item) => {
                      return (
                        <li
                          key={item.code.toString()}
                          className={cx(
                            'bullet',
                            {
                              red: item.risk === 'critical',
                            },
                            {
                              orange: item.risk === 'high',
                            },
                            {
                              cheese: item.risk === 'medium',
                            },
                            {
                              yellow: item.risk === 'low',
                            }
                          )}
                        >
                          <span
                            className="name has_link"
                            onClick={(e) => {
                              return this.handleSecurityDetailModal(e, item.code);
                            }}
                            onKeyUp={(e) => {
                              return this.handleSecurityDetailModal(e, item.code);
                            }}
                          >
                            {item.code}
                            {item.is_exploit ? (<Icon name="bug" />) : null}
                          </span>
                          <span className="val">{item.uploaded_file_count}</span>
                        </li>
                      );
                    })
                    : null}
                </ul>
              </div>
            </td>
            <td>
              <div className="list_wrap">
                <p className="list_title">{translate('panel.menu.most_critical_security_risks')}</p>
                <ul>
                  {this.props.file.mostVulnerable
                    ? this.props.file.mostVulnerable.map((item) => {
                      return (
                        <li
                          key={item.code.toString()}
                          className={cx(
                            'bullet',
                            {
                              red: item.risk === 'critical',
                            },
                            {
                              orange: item.risk === 'high',
                            },
                            {
                              cheese: item.risk === 'medium',
                            },
                            {
                              yellow: item.risk === 'low',
                            }
                          )}
                        >
                          <span
                            className="name has_link"
                            onClick={(e) => {
                              return this.handleSecurityDetailModal(e, item.code);
                            }}
                            onKeyUp={(e) => {
                              return this.handleSecurityDetailModal(e, item.code);
                            }}
                          >
                            {item.code}
                            {item.is_exploit ? (<Icon name="bug" />) : null}
                          </span>
                          <span className="val">{item.uploaded_file_count}</span>
                        </li>
                      );
                    })
                    : null}
                </ul>
              </div>
              <SecurityDetailModal
                isOpenMSD={this.state.isOpenMSD}
                closeModal={this.handleMSDClose}
                cveData={cveData}
                selectedCode={this.state.selectedCode}
                translate={translate}
              />
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}
/*
SecuritySummaryView.defaultProps = {
  file: {},
};
*/

export default SecuritySummaryView;
